import React from 'react';
import { FaPlus, FaTrash, FaPen, FaUser, FaRegClock, FaChevronRight } from 'react-icons/fa';
import Pill from '../EntityList/Pill';

const TYPE_CONFIG = {
	created: { icon: FaPlus, iconClassName: 'hist-ico-ok' },
	deleted: { icon: FaTrash, iconClassName: 'hist-ico-danger' },
	modified: { icon: FaPen, iconClassName: 'hist-ico-neutral' },
};

function titleFor(entry) {
	if (entry.type === 'created') return 'Registro creado';
	if (entry.type === 'deleted') return 'Registro eliminado';
	return entry.changes.length > 1 ? 'Se modificaron varios campos' : 'Campo modificado';
}

function HistoryCard({ entry }) {
	const { icon: Icon, iconClassName } = TYPE_CONFIG[entry.type];
	const title = entry.recordLabel ? `${entry.recordLabel} - ${titleFor(entry)}` : titleFor(entry);

	return (
		<div className={`hist-card ${entry.type}`}>
			<div className='hist-card-hd'>
				<div className={`hist-ico ${iconClassName}`}><Icon size={13} /></div>
				<div className='hist-card-main'>
					<div className='hist-title'>{title}</div>
					<div className='hist-meta'>
						<FaUser size={11} /> {entry.user}
						<span className='sep'>·</span>
						<FaRegClock size={11} /> {entry.date} {entry.time}
					</div>
				</div>
			</div>
			{entry.changes.length > 0 && (
				<div className='hist-changes'>
					{entry.changes.map((change, index) => (
						<div className='hist-change-row' key={index}>
							<span className='hist-field'>{change.field}</span>
							<span className='hist-old'>{change.from}</span>
							<FaChevronRight className='hist-arrow' size={10} />
							<span className='hist-new'>{change.to}</span>
						</div>
					))}
				</div>
			)}
			{entry.option && (
				<div className='hist-opt'>
					<Pill tone='neutral'>{entry.option}</Pill>
				</div>
			)}
		</div>
	);
}

export default HistoryCard;
